import { memo } from "react";

import classnames from "classnames";
import { Neeto } from "neetoicons/typeface-logos";
import * as AppIcons from "neetoicons/typeface-logos";
import { Typography } from "neetoui";

import { SPECIAL_APP_NAMES } from "./constants";
import "./product-switcher.scss";

const ProductLink = ({
  name,
  description,
  url,
  isHighlighted = false,
  ...props
}) => {
  const normalizedName = (name || "").toLowerCase();
  const specialCase = SPECIAL_APP_NAMES[normalizedName];

  const appName = `Neeto${name.charAt(0)}${name.slice(1).toLowerCase()}`;

  const AppIcon = specialCase
    ? AppIcons[`Neeto${specialCase}`]
    : AppIcons[appName];

  return (
    <a
      data-testid={`${normalizedName}-app-link`}
      href={url}
      rel="noreferrer"
      target="_blank"
      className={classnames("neeto-molecules-product-switcher-link", {
        "neeto-molecules-product-switcher-link--active":
          globalProps.appName.includes(name),
        "neeto-molecules-product-switcher-link--highlighted": isHighlighted,
      })}
      {...props}
    >
      <div className="neeto-molecules-product-switcher-link__icon-holder">
        {AppIcon ? (
          <AppIcon />
        ) : (
          <Neeto className="neeto-molecules-product-switcher-link__icon-default" />
        )}
      </div>
      <div className="neeto-molecules-product-switcher-link__content">
        <Typography
          className="neeto-ui-text-gray-600"
          component="span"
          style="body3"
          weight="normal"
        >
          {description}
        </Typography>
      </div>
    </a>
  );
};

export default memo(ProductLink);
